import React from 'react';
import { useState } from 'react';

const IndScreen = ({ appScreens, webScreens, tabLabels }) => {
  const [screen, setTab] = useState('app');

  const handleChange = e => setTab(e.target.value);

  return (
    <section className="index-screens">
      <input
        type="radio"
        value="app"
        id="app"
        className="index-screens-input index-screens-input-app"
        onChange={handleChange}
        checked={screen === 'app'}
        name="screen"
      />
      <input
        type="radio"
        value="web"
        id="web"
        className="index-screens-input index-screens-input-web"
        onChange={handleChange}
        checked={screen === 'web'}
        name="screen"
      />
      <div className="index-screens-togglers">
        <label className="index-screens-toggler index-screens-toggler-app"
               htmlFor="app" children={tabLabels.label1}/>
        <label className="index-screens-toggler index-screens-toggler-web"
               htmlFor="web" children={tabLabels.label2}/>
      </div>
      <div className="index-screens-wrap">
        <div className="index-screens-item">
          <div
            className="container-block js--index-screens-slider-app"
          >
            {appScreens.map((el, index) => (
                <figure
                  className="index-screens-item-app"
                  key={index}
                  style={{ minHeight: '503.234px' }}
                >
                  <picture>
                    <img
                      className="index-screens-item-app-img"
                      src={el.img1x}
                      alt={el.alt}
                      title={el.alt}
                    />
                  </picture>
                </figure>
              ))}
          </div>
        </div>
        <div className="index-screens-item">
          <div className="container-block js--index-screens-slider-web">
            {webScreens.map((el, index) => (
                <figure className="index-screens-item-web" key={index}>
                  <picture>
                    <source media="(min-width: 731px)" srcSet={el.imgWebp1x} type="image/webp" />
                    <source
                      media="(max-width: 730px)"
                      data-flickity-lazyload={el.imgWebp1x}
                      type="image/webp"
                    />
                    <source
                      media="(min-width: 731px)"
                      data-flickity-lazyload={el.img1x}
                      type="image/png"
                    />
                    <source
                      media="(max-width: 730px)"
                      data-flickity-lazyload={el.imgSmall1x}
                      type="image/png"
                    />
                    <img
                      src={el.img1x}
                      alt={el.alt}
                      title={el.alt}
                      className="index-screens-item-web-img"
                      loading="lazy"
                    />
                  </picture>
                </figure>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndScreen;
